var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMeetingLines(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1410,
    height: 1310,
    viewBox: "0 0 1410 1310",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 0V326.87C10 371.053 45.8172 406.87 90 406.87H250.105C294.287 406.87 330.105 442.687 330.105 486.87V1220C330.105 1264.18 365.922 1300 410.105 1300H1264.24C1308.42 1300 1344.24 1264.18 1344.24 1220V928.987C1344.24 892.669 1373.68 863.229 1410 863.229V863.229",
    stroke: "white",
    strokeOpacity: 0.1,
    strokeWidth: 20
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMeetingLines);
export default __webpack_public_path__ + "static/media/MeetingLines.99ac8d70c907082a82425d4fc5321468.svg";
export { ForwardRef as ReactComponent };